import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Mail, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { clientApi } from "@/lib/api";
import { toast } from "sonner";
import { LOGO_URL } from "@/lib/constants";

export default function ClientLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await clientApi.post("/client/auth/login", { email, password });
      localStorage.setItem("pn_client_token", data.token);
      localStorage.setItem("pn_client_name", data.name);
      localStorage.setItem("pn_client_email", data.email);
      toast.success(`Bienvenue ${data.name.split(" ")[0]} !`);
      nav("/portail");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Identifiants invalides");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F7FA] px-6" data-testid="client-login-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 border border-gray-200">
        <Link to="/" className="flex items-center gap-3 justify-center mb-6">
          <img src={LOGO_URL} alt="Logo" className="h-14 w-14 object-contain" />
        </Link>
        <div className="text-center">
          <div className="text-[#00B8D9] text-xs tracking-[0.2em] uppercase font-bold mb-2">Portail Client</div>
          <h1 className="font-heading font-extrabold text-2xl text-[#0B1F3A]">Bienvenue</h1>
          <p className="text-sm text-[#4B5563] mt-1 mb-6">Accédez à vos projets, livrables et factures.</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Courriel</Label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="pl-9" data-testid="client-login-email" />
            </div>
          </div>
          <div>
            <Label>Mot de passe</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="pl-9" data-testid="client-login-password" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#00B8D9] hover:bg-[#0096B3] font-semibold py-6" data-testid="client-login-submit">
            {loading ? "Connexion..." : <>Se connecter <ArrowRight className="ml-2 h-4 w-4" /></>}
          </Button>
        </form>

        <div className="mt-6 text-center text-xs text-[#4B5563]">
          Pas encore de compte ? <Link to="/contact" className="text-[#00B8D9] font-semibold hover:underline">Contactez-nous</Link>
        </div>
        <div className="mt-2 text-center">
          <Link to="/" className="text-xs text-[#4B5563] hover:text-[#00B8D9]">← Retour au site</Link>
        </div>
      </div>
    </div>
  );
}
